import MemberCardKeys from '@/components/MemberCardKeys';
import { IMembershipCardData } from '@/components/MembershipCardModal';
import { IMemberCardKey, IMemberCardKeyResonse } from '@/types';
import { fetchTemplate } from '@/utils/isServer';

class MemberCardKeyService {
  public async GetMemberKeyCards(): Promise<Array<IMemberCardKey>> {
    const res = await fetch(`/api/MemberCardKeyBT`, {
      ...fetchTemplate,
      method: 'get',
    });

    const memberCardKeysResponse: IMemberCardKeyResonse = await res.json();
    if (memberCardKeysResponse.status == 'OK')
      return memberCardKeysResponse.data;
    return [];
  }
  public async AddCard(card: IMemberCardKey): Promise<any> {
    const res = await fetch(`/api/MemberCardKeyBT`, {
      ...fetchTemplate,
      body: JSON.stringify(card),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return await res.json();
  }
  public async DeleteCard(member_cardkey_id: number): Promise<any> {
    const res = await fetch(`/api/MemberCardKeyBT/${member_cardkey_id}`, {
      ...fetchTemplate,
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return await res.json();
  }
}

export default new MemberCardKeyService();
